import React, { FC } from 'react';
import PolygonItem, { PolygonItemType } from './polygon-item';
import { CoKitchenPolygons } from 'utils/types';
import { POLYGON_COLORS } from 'utils/constants';
import { Button } from '@cokitchen/cokitchen-components';
import { AddIcon } from 'cokitchen-icons';

type PolygonCardProps = {
  polygons: CoKitchenPolygons[];
  setActivePolygon: (polygon: CoKitchenPolygons) => void;
  list: PolygonItemType[];
  showAddButton?: () => void;
};

const PolygonCard: FC<PolygonCardProps> = ({ polygons, list, setActivePolygon, showAddButton }) => {
  const sortedPolygons = polygons.sort((a, b) => a.name.localeCompare(b?.name));
  return (
    <div className='overflow-y-auto min-w-[100%] rounded-2xl border border-[#EFF0F0] '>
      <div className='flex justify-between items-center border-b border-[#EFF0F0] py-3 px-6'>
        <h2 className='text-sm text-gray-5 uppercase tracking-wider'>Polygons</h2>

        {showAddButton && (
          <Button onClick={showAddButton} small variant='link' color='primary' className='text-xs'>
            <AddIcon /> Add New
          </Button>
        )}
      </div>

      <div className='py-5 px-6 space-y-4 h-[calc(100%-90px)] max-h-[495px] overflow-auto '>
        {sortedPolygons?.map((polygon, index) => (
          <PolygonItem
            list={list}
            onClick={() => setActivePolygon(polygon)}
            key={index}
            color={POLYGON_COLORS[index % POLYGON_COLORS.length]?.color_code ?? '#ccc'}
            name={polygon.name}
          />
        ))}
      </div>
    </div>
  );
};

export default PolygonCard;
